import { render } from "./CheckoutOrder.vue?vue&type=template&id=447ca062"
import script from "./CheckoutOrder.vue?vue&type=script&lang=js"
export * from "./CheckoutOrder.vue?vue&type=script&lang=js"

import "./CheckoutOrder.vue?vue&type=style&index=0&id=447ca062&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__